// import React, { useState } from 'react';
// import { useStripe, useElements, CardElement } from '@stripe/react-stripe-js';
// import axios from 'axios';
// import './PaymentForm.css';
// import { useNavigate } from 'react-router-dom';
// import { useLocation } from 'react-router-dom';



// const PaymentForm = () => {
//   const stripe = useStripe();
//   const elements = useElements();
//   const navigate = useNavigate();
  
//   // const [amount, setAmount] = useState('');
//   // const [description, setDescription] = useState('');
//   const [loading, setLoading] = useState(false);
//   const [message, setMessage] = useState('');
//   const [paymentStatus, setPaymentStatus] = useState('');
//       const token = localStorage.getItem('authToken'); // or wherever you're storing the token
//       const location = useLocation();
// const { amount: initialAmount, description: initialDescription, planId } = location.state || {};

// const [amount, setAmount] = useState(initialAmount || '');
// const [description, setDescription] = useState(initialDescription || '');


//   const serverUrl = process.env.REACT_APP_SERVER_URL || 'http://localhost:5000';
//   const serverUrl2 = 'https://beta.flowlogic.com/api/subscriptions';


//   const handleSubmit = async (event) => {
//   event.preventDefault();

//   if (!stripe || !elements) return;

//   if (!amount || amount <= 0) {
//     setMessage('Please enter a valid amount');
//     return;
//   }

//   const amountInCents = Math.round(parseFloat(amount) * 100);
//   setLoading(true);
//   setMessage('');
//   setPaymentStatus('');

//   try {
//     // const { data } = await axios.post(
//     //   'https://beta.flowlogic.com/api/subscriptions/create-intent/',
//     //   { amount: amountInCents },
//     //   {
//     //     headers: {
//     //       Authorization: `Bearer ${token}`,
//     //       'Content-Type': 'application/json',
//     //     },
//     //   }
//     // );

//     const { data } = await axios.post(
//   `${serverUrl2}/create-intent/`,
//   {
//     amount: amountInCents,
//     description: description,
//     plan_id: planId, // ✅ Send plan ID
//   },
//   {
//     headers: {
//       Authorization: `Bearer ${token}`,
//       'Content-Type': 'application/json',
//     },
//   }
// );


//     const clientSecret = data.clientSecret || data.client_secret;

//     if (!clientSecret) {
//       setMessage('Failed to retrieve payment information.');
//       setLoading(false);
//       return;
//     }

//     const result = await stripe.confirmCardPayment(clientSecret, {
//       payment_method: {
//         card: elements.getElement(CardElement),
//         billing_details: { name: 'Customer' },
//       },
//     });

//     if (result.error) {
//       setMessage(result.error.message || 'Payment failed.');
//       setPaymentStatus('failed');

//       navigate('/payment-failure', {
//         state: {
//           error: result.error,
//           amount,
//           description,
//           source: 'payment_form',
//         },
//       });
//     } else if (result.paymentIntent.status === 'succeeded') {
//       navigate('/payment-success', {
//         state: {
//           paymentIntent: result.paymentIntent,
//           amount,
//         },
//       });
//     } else {
//       setMessage('Payment processing. Please wait...');
//       setPaymentStatus('processing');
//     }
//   } catch (error) {
//     console.error('Payment error:', error);
//     setMessage('Payment failed. Please try again.');
//     setPaymentStatus('failed');
//   }

//   setLoading(false);
// };

//   const handleSubmit1 = async (event) => {
//     event.preventDefault();
    
//     if (!stripe || !elements) {
//       return;
//     }

//     if (!amount || amount <= 0) {
//       setMessage('Please enter a valid amount');
//       return;
//     }

//     setLoading(true);
//     setMessage('');
//     setPaymentStatus('');

//     try {
//       // Create payment intent
//       // const { data } = await axios.post(`${serverUrl}/create-payment-intent`, {
//       // const { data } = await axios.post(`${serverUrl2}/create-intent`, {
//       //   amount: parseFloat(amount),
//       //   description: description || 'Payment'
//       // });


// // const { data } = await axios.post(`${serverUrl2}/create-payment-intent`, {
// const { data } = await axios.post(`${serverUrl2}/create-intent`, {
  
//   amount: parseFloat(amount),
//   // description: description || 'Payment'
// }, {
//   headers: {
//     Authorization: `Bearer ${token}`,
//     'Content-Type': 'application/json'
//   }
// });

//       console.log('Payment intent data:', data);
//       if (!data || !data.clientSecret) {
//         setMessage('Failed to create payment intent. Please try again.');
//         setLoading(false);
//         return;
//       }

//       const { clientSecret } = data;

//       // Confirm payment
//       const result = await stripe.confirmCardPayment(clientSecret, {
//         payment_method: {
//           card: elements.getElement(CardElement),
//           billing_details: {
//             name: 'Customer',
//           },
//         }
//       });
//       console.log('Payment confirmation result:', result);

//       if (result.error) {
//         // setMessage(`Payment failed: ${result.error.message}`);
//               // Handle different types of payment errors
//               if (result.error.type === 'card_error' || result.error.type === 'validation_error') {
//                 setMessage(`Payment failed: ${result.error.message}`);
//               } else {
//                 setMessage('An unexpected error occurred. Please try again.');
//               }
//         setPaymentStatus('failed');

//         console.error('Payment confirmation error:', result.error);
        
//         // Navigate to failure page with error details
//         navigate('/payment-failure', {
//           state: {
//             error: result.error,
//             amount: amount,
//             description: description,
//             source: 'payment_form'
//           }
//         });
//       } 
//       // else {
//         else if (result.paymentIntent && result.paymentIntent.status === 'succeeded') {
//           console.log('Payment succeeded:', result.paymentIntent);
//         // setMessage('Payment succeeded!');
//         // setPaymentStatus('succeeded');
//         // setAmount('');
//         // setDescription('');
//         // elements.getElement(CardElement).clear();

// navigate('/payment-success', { 
//   state: { 
//     paymentIntent: result.paymentIntent,
//     amount: amount,
//     // description: description 
//   }
// });
//       }
//       else {
//         // Handle other payment statuses
//         console.log('Payment status:', result.paymentIntent?.status);
//         setMessage('Payment processing. Please wait...');
//         setPaymentStatus('processing');
//       }

//     } catch (error) {
//       console.error('Error during payment confirmation:', error);
//         setMessage('Payment confirmation failed. Please try again.');
//       // setMessage(`Error: ${error.response?.data?.error || error.message}`);
//       setPaymentStatus('failed');
//     }

//     setLoading(false);
//   };

//   const cardElementOptions = {
//     style: {
//       base: {
//         fontSize: '16px',
//         color: '#424770',
//         '::placeholder': {
//           color: '#aab7c4',
//         },
//       },
//       invalid: {
//         color: '#9e2146',
//       },
//     },
//   };

//   return (
//     <>
//     {planId && (
//   <div className="plan-summary">
//     <h3>Selected Plan</h3>
//     <p><strong>Description:</strong> {description}</p>
//     <p><strong>Amount:</strong> ${amount}</p>
//   </div>
// )}

//     <div className="payment-form-container">
//       <div className="payment-form">
//         <h2>Make a Payment</h2>
        
//         <form onSubmit={handleSubmit}>
//           {/* 
//           <div className="form-group">
//             <label htmlFor="amount">Amount (USD)</label>
//             <input
//               type="number"
//               id="amount"
//               value={amount}
//               onChange={(e) => setAmount(e.target.value)}
//               placeholder="Enter amount"
//               min="0.50"
//               step="0.01"
//               required
//             />
//           </div> */}

//           <div className="form-group">
//             <label htmlFor="amount">Amount (USD)</label>
//           <input
//   type="number"
//   id="amount"
//   value={amount}
//   onChange={(e) => setAmount(e.target.value)}
//   placeholder="Enter amount"
//   min="0.50"
//   step="0.01"
//   required
//   disabled={!!initialAmount} // ✅ disable if prefilled
// />
//     </div>


//           <div className="form-group">
//             <label htmlFor="description">Description (Optional)</label>
//             <input
//               type="text"
//               id="description"
//               value={description}
//               onChange={(e) => setDescription(e.target.value)}
//               placeholder="Payment description"
//             />
//           </div>

//           <div className="form-group">
//             <label>Card Details</label>
//             <div className="card-element">
//               <CardElement options={cardElementOptions} />
//             </div>
//           </div>

//           <button 
//             type="submit" 
//             disabled={!stripe || loading}
//             className={`pay-button ${loading ? 'loading' : ''}`}
//           >
//             {loading ? 'Processing...' : `Pay $${amount || '0.00'}`}
//           </button>
//         </form>

//         {message && (
//           <div className={`message ${paymentStatus}`}>
//             {message}
//           </div>
//         )}
// {/* 
//         <div className="test-cards">
//           <h3>Test Card Numbers</h3>
//           <p><strong>Success:</strong> 4242 4242 4242 4242</p>
//           <p><strong>Declined:</strong> 4000 0000 0000 0002</p>
//           <p>Use any future date for expiry and any 3-digit CVC</p>
//         </div> */}
//       </div>
//     </div>
//     </>
//   );
// };

// export default PaymentForm;



import React, { useState } from 'react';
import axios from 'axios';
import { loadStripe } from '@stripe/stripe-js';
import './PaymentForm.css';
import { useLocation } from 'react-router-dom';

const stripePromise = loadStripe('pk_test_51Rq76fC5GKbLs6Mr7iQHl54rJYZp3Vz23CnFaBH1EodYvSb10oFyaPnWz3pz9xy60wfiSu0s4S5iEqWxn3s3SF8q00YXARdHV9'); // ✅ Replace with your Stripe publishable key

const PaymentForm = () => {
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const location = useLocation();
  const token = localStorage.getItem('authToken');

  const {
    amount: initialAmount,
    description: initialDescription,
    planId,
  } = location.state || {};

  const amount = initialAmount;
  const description = initialDescription;
  // const serverUrl = 'https://beta.flowlogic.com/api/subscriptions';
  const serverUrl = 'http://localhost:5000'; 
  

  const handleCheckout = async () => {
    setLoading(true);
    setMessage('');

    try {
      const stripe = await stripePromise;

      const response = await axios.post(
        `${serverUrl}/create-checkout-session/`,
        {
          amount: Math.round(amount * 100),
          description,
          plan_id: planId,
          success_url: `${window.location.origin}/payment-success1`,
          cancel_url: `${window.location.origin}/payment-failure`,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        }
      );

      const sessionId = response.data.sessionId;

      if (!sessionId) {
        setMessage('Failed to create checkout session.');
        setLoading(false);
        return;
      }

      // Redirect to Stripe Checkout
      const result = await stripe.redirectToCheckout({ sessionId });

      if (result.error) {
        setMessage(result.error.message);
      }
    } catch (error) {
      console.error(error);
      setMessage('Something went wrong. Try again.');
    }

    setLoading(false);
  };
  

  return (
    <div className="payment-page-container">
      <div className="plan-summary-box">
        <h3>Selected Plan</h3>
        <p><strong>Description:</strong> {description}</p>
        <p><strong>Amount:</strong> ${amount}</p>
      </div>

      <div className="payment-form-box">
        <h2>Proceed to Payment</h2>
        <button
          className="pay-button"
          onClick={handleCheckout}
          disabled={loading}
        >
          {loading ? 'Redirecting...' : `Pay $${amount}`}
        </button>

        {message && <div className="message">{message}</div>}
      </div>
    </div>
  );
};

export default PaymentForm;

